module.exports = __webpack_public_path__ + "0f68fbdb7eefce25b30d1dad4169c3fc.svg";